'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoHammer = function IoHammer(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32 2.5c0.3 0 0.5 0.2 0.5 0.5v6.5c0 0.3-0.2 0.5-0.5 0.5h-4c-0.3 0-0.5-0.2-0.5-0.5v-1.1c-0.5-0.4-1.2-0.7-1.7-0.5-0.6 0.1-1.8 1-2.4 1.9s-0.4 2.2-0.4 5.2l0.6 0.2c0.4 0 0.5 0.4 0.5 0.7v5.4c0 7.5 0.9 15.7 0.9 15.7 0 0.3-0.2 0.5-0.5 0.5h-6.5c-0.3 0-0.5-0.2-0.5-0.5 0 0 0.9-8.2 0.9-15.7v-5.4c0-0.3 0.2-0.7 0.5-0.7l0.5-0.2c0-3.4-0.3-4.5-1.7-5.8-1.4-1.2-3.2-1.5-4.9-1.3s-4 2.7-4.5 3.5-0.8-0.1-0.8-0.9c0.1-1.2 1.7-4.6 5.6-6.3s7.1-1.7 8-1.7 2.1 0.1 3 0.2 1.2 1.4 2 1.4c0.5 0 1.1-0.3 1.4-0.7v-0.4c0-0.3 0.2-0.5 0.5-0.5h4z' })
        )
    );
};

exports.default = IoHammer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/hammer.js
// module id = 2273
// module chunks = 0